<template>
  <div
    ref="app"
    class="app"
    @scroll="scrollChange()"
  >
    <div
      v-if="!showPop"
      class="fixed-view flx-col-ctr"
      :style="`opacity: ${isFixed ? '1' : '0'};margin-top: ${isFixed ? '0' : '-50px'}`"
    >
      {{ projectInfo.name }}
    </div>
    <!-- 顶部滚动banner -->
    <van-swipe
      ref="swiper"
      :autoplay="5000"
      :show-indicators="false"
      :width="clientWidth"
      @change="swiperChange"
    >
      <van-swipe-item
        v-for="(item, index) in BANNER_INFO"
        :key="`item-${index}`"
        class="content-item flx-col-ctr"
      >
        <van-image
          width="10rem"
          :src="item"
          :show-error="false"
          :show-loading="false"
        />
      </van-swipe-item>
      <template #indicator>
        <div class="flx-ctr custom-indicator">
          <span
            v-for="index in BANNER_INFO.length"
            :key="index"
            :class="['item', current === (index - 1) ? 'current' : '']"
          />
        </div>
      </template>
    </van-swipe>
    <!-- 主要内容 -->
    <div class="content-view">
      <!-- 项目主要信息模块 -->
      <div class="info-view flx-row-btw">
        <div class="title">
          <p class="name">
            {{ projectInfo.name }}
          </p>
          <p
            v-if="projectInfo.tagInfo"
            class="tag"
          >
            <span
              v-for="(tag, index) in projectInfo.tagInfo"
              :key="`tag-${index}`"
              class="item"
            >{{ tag }}</span>
          </p>
        </div>
        <!-- 分享 -->
        <!-- <div class="share">
          <a
            href=""
            class="flx-ctr"
          >
            <van-icon name="share" />分享
          </a>
        </div> -->
      </div>
      <!-- 项目价格区域 -->
      <div class="price-view">
        {{ projectInfo.price || '价格待定' }}
      </div>
      <div class="split-line-w" />
      <!-- 项目基础信息 -->
      <div class="base-info">
        <ul class="form-readonly">
          <li class="flx-row-str">
            <span class="label">占地面积：</span>
            <span class="value">{{ projectInfo.area }}</span>
          </li>
          <li class="flx-row-str">
            <span class="label">建筑面积：</span>
            <span class="value">{{ projectInfo.coveredArea }}</span>
          </li>
          <li class="flx-row-str">
            <span
              class="label"
            >项目坐标：</span>
            <span
              class="value flx-ctr"
              style="color: #75b8fc;"
              @click="jumpTo(navUrl);"
            >
              <van-image
                :src="require('@/imgs/icon/nav_b2.png')"
                :show-error="false"
                :show-loading="false"
                width="16px"
                style="margin: 3px 4px 0 0;"
              />
              {{ projectInfo.addr }}
            </span>
          </li>
        </ul>
        <van-button
          class="lg-btn detail-btn"
          type="info"
          size="large"
          @click="jumpTo('/xinyi/app.html#/info')"
        >
          查看详细介绍
        </van-button>
      </div>
    </div>
    <!-- 全景看房 -->
    <div class="tag-view tour-view">
      <div class="tag-title">
        全景看房
      </div>
      <div class="full-img">
        <van-image
          width="9.4rem"
          radius="10"
          :src="BANNER_INFO[0]"
          :show-error="false"
          :show-loading="false"
        >
          <div
            class="abs flx-col-ctr"
            style="width: 100%;height: 100%"
            @click="jumpTo('/xinyi/index.html')"
          >
            <span class="inline-btn flx-col-ctr">
              <van-image
                width="32px"
                style="padding: 10px"
                :src="require('@/imgs/index/nav/sand_h.png')"
                :show-error="false"
                :show-loading="false"
              />

            </span>
          </div>
        </van-image>
      </div>
    </div>
    <!-- 带我看户型 -->
    <div class="tag-view house-view">
      <div class="tag-title">
        带我看户型
      </div>
      <div class="houses flx-row-str">
        <van-image
          v-for="(item, index) in HOUSE_IMGS"
          :key="`item-${index}`"
          :src="item"
          :show-error="false"
          :show-loading="false"
          width="100px"
          class="item"
          @click="jumpTo(`/xinyi/index.html#/house?type=${index}`)"
        />
      </div>
    </div>
    <!-- 项目图片 -->
    <div class="tag-view project-view">
      <div class="tag-title">
        项目图片
      </div>
      <div class="imgs flx-row-btw">
        <van-image
          :src="BANNER_INFO[0]"
          :show-error="false"
          :show-loading="false"
          width="61%"
          height="100%"
          fit="fill"
          class="item"
        />
        <span
          class="flx-col-btw"
          style="width: 35%;height: 100%;"
        >
          <van-image
            :src="BANNER_INFO[1]"
            :show-error="false"
            :show-loading="false"
            width="100%"
            height="47%"
            fit="fill"
            class="item"
          />
          <van-image
            :src="BANNER_INFO[2]"
            :show-error="false"
            :show-loading="false"
            width="100%"
            height="47%"
            fit="fill"
            class="item"
          />
        </span>
      </div>
    </div>
    <!-- 咨询置业顾问-生成分享链接 -->
    <div
      v-if="!isShareView"
      class="tag-view zy-view"
    >
      <div class="flx-row-btw">
        <div class="tag-title">
          咨询置业顾问
        </div>
        <span
          class="flx-ctr"
          style="font-size: 14px;color: rgba(0,0,0,0.6)"
          @click="jumpTo('/xinyi/app.html#/appoint')"
        >
          查看更多
          <van-icon
            name="arrow"
            style="margin: 2px 0 0 4px;"
          />
        </span>
      </div>
      <div class="contact-info">
        <template v-for="(item, index) in CONTACTS_INFO.slice(0, 5)">
          <div
            :key="index"
            class="item flx-row-btw"
          >
            <div
              class="flx-row-str"
              style="width: 40%"
            >
              <span class="avatar">
                <img
                  v-if="item.img"
                  :src="item.img"
                  style="object-fit: cover;"
                >
                <span
                  v-else
                  class="default flx-ctr"
                >
                  <van-image
                    :src="require('@/imgs/icon/contact.png')"
                    :show-error="false"
                    :show-loading="false"
                    width="32px"
                  />
                </span>
              </span>
              <span class="text flx-col-ctr">
                <span style="margin-bottom: 3px">{{ item.name }}</span>
                <span style="color: rgba(0,0,0,0.6);font-size: 11px;">{{ item.title }}</span>
              </span>
            </div>
            <span
              v-if="isNormalView"
              class="call-btn flx-ctr"
              @click="phoneCall(item.phone)"
            >
              <van-icon
                name="phone-o"
                style="margin: 3px 4px 0 0"
              />
              <span>呼叫</span>
            </span>
            <span
              v-else
              class="call-btn flx-ctr"
              @click="onShare(index)"
            >
              <van-icon
                name="share-o"
                style="margin: 3px 4px 0 0"
              />
              <span>分享</span>
            </span>
          </div>
          <div
            :key="`phone-${index}`"
            class="split-line-w"
          />
        </template>
      </div>
    </div>
    <!-- 咨询置业顾问-咨询 -->
    <div
      v-if="isShareView"
      style="width: 10rem;height: 54px;"
    />
    <div
      v-if="isShareView"
      class="gw-view"
    >
      <div class="item flx-row-btw">
        <div
          class="flx-row-str"
          style="width: 40%"
        >
          <span class="avatar">
            <img
              :src="CONTACTS_INFO[shareIndex].img"
              style="object-fit: cover;"
            >
          </span>
          <span class="text flx-col-ctr">
            <span style="margin-bottom: 3px">{{ CONTACTS_INFO[shareIndex].name }}</span>
            <span style="color: rgba(0,0,0,0.6);font-size: 11px;">{{ CONTACTS_INFO[shareIndex].title }}</span>
          </span>
        </div>
        <span
          class="call-btn flx-ctr"
          @click="phoneCall(CONTACTS_INFO[shareIndex].phone)"
        >
          <van-icon
            name="phone-o"
            style="margin: 3px 4px 0 0"
          />
          <span>呼叫</span>
        </span>
      </div>
    </div>
    <!-- 分享提示 -->
    <van-overlay
      :show="showPop"
      @click="showPop = false"
    >
      <div
        class="wrapper flx-col-ctr"
      >
        <van-image
          class="abs-r"
          style="right: 24px;top: 1vh;"
          :src="require('@/imgs/share_arrow.png')"
          :show-error="false"
          :show-loading="false"
          width="156px"
        />
        <p
          style="margin-top: 240px;color: #fff"
        >
          点击左上角按钮，分享给朋友
        </p>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {
  Button, Swipe, SwipeItem, Sticky, Overlay,
} from 'vant';
import { BANNER_INFO, HOUSE_IMGS, CONTACTS_INFO } from '@/libs/config/app';
import { wexinShare, getQueryParams } from '@/libs/util';
import { getWeChatSignature } from '@/libs/api';

const navUrl = 'https://map.qq.com/m/place/info/uid=1450284733098685929&word=%E4%BF%A1%E4%B9%89%E9%87%91%E5%BE%A1%E5%8D%8A%E5%B1%B1%E8%90%A5%E9%94%80%E4%B8%AD%E5%BF%83&type=point';
export default {
  components: {
    [Button.name]: Button,
    [Sticky.name]: Sticky,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Overlay.name]: Overlay,
  },
  data() {
    return {
      HOUSE_IMGS,
      BANNER_INFO,
      CONTACTS_INFO,
      projectInfo: {
        name: '信义金御半山·珑门',
        tagInfo: ['信义控股集团'],
        area: '约23002㎡',
        coveredArea: '约175495㎡',
        addr: '深圳都市核心区·5号线百鸽笼站',
      },
      clientWidth: 0,
      current: 0,
      isFixed: false,
      navUrl,
      showPop: false,
      isNormalView: true, // 普通的视图
      isShareView: false, // 分享视图
      shareIndex: 0,
    };
  },
  mounted() {
    // 正确设置swiper宽度
    this.clientWidth = document.body.clientWidth;
    const { share = '0' } = this.$route.query;

    const si = getQueryParams('si') || '';
    if (share === '1') {
      this.isNormalView = false;
    }
    if (si) {
      this.isShareView = true;
      this.shareIndex = si;
    }
  },
  methods: {
    // swiper组件下标改变
    swiperChange(index) {
      this.current = index;
    },
    scrollChange() {
      const { scrollTop } = this.$refs.app;
      this.isFixed = scrollTop > 100;
    },
    // 打电话
    phoneCall(num) {
      const phoneUrl = `tel:${num}`;
      window.location.href = phoneUrl;
    },
    jumpTo(url) {
      window.location.href = url;
    },
    // 生成分享链接
    onShare(index) {
      this.showPop = true;
      // 请求微信配置参数接口（获取签名），由后台给接口给
      const url = window.location.href.split('#')[0];
      // 看后台请求接口是get/post
      getWeChatSignature({ url }).then((res) => {
        const {
          return_data: { signature, timestamp },
        } = res;
          // 微信加签
        const obj = {
          debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
          timestamp, // 必填，生成签名的时间戳
          signature, // 必填，签名
        };
        const shareData = {
          link: `${url}?si=${index}`,
          desc: 'VR带看',
        };
        // 引用
        wexinShare(obj, shareData);
      });
    },
  },
};
</script>
<style lang="less" scoped>
@contentMT: 5vh;
.app {
  height: 100vh;
  overflow-y: scroll;
  background-color: #f8f8f8;
  padding-bottom: 25px;
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .project-view {
    padding: 12px 0;
    .imgs {
      padding: 8px;
      height: 140px;
    }
  }
  .gw-view {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 10rem;
    height: 74px;
    background-color: #ffffff;
    .item {
      width: 90%;
      height: 100%;
      margin-left: 5%;
    }
    .text {
      align-items: flex-start;
      margin-left: 18px;
    }
    .avatar {
      img {
        width: 52px;
        height: 52px;
        border-radius: 50%;
      }
      & .default {
        width: 52px;
        height: 52px;
        border-radius: 50%;
        background-color: #eff0f4;
      }
    }
    .call-btn {
      width: 2rem;
      height: .8rem;
      color: #f4f4f4;
      border-radius: 50px;
      background-image: linear-gradient(to bottom, rgba(7, 193, 96, .8), rgba(7, 193, 96, 1));
    }
  }
  .zy-view {
    .contact-info {
      width: 100%;
      overflow: hidden;
      font-size: 15px;
      .item {
        margin: 15px 0;
        .text {
          align-items: flex-start;
          margin-left: 18px;
        }
        .avatar {
          img {
            width: 52px;
            height: 52px;
            border-radius: 50%;
          }
          & .default {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            background-color: #eff0f4;
          }
        }
      }
      .call-btn {
        width: 2rem;
        height: .8rem;
        color: #f4f4f4;
        border-radius: 50px;
        background-image: linear-gradient(to bottom, rgba(7, 193, 96, .8), rgba(7, 193, 96, 1));
      }
    }
  }
  .tour-view {
    .full-img {
      margin-top: 12px;
    }
  }
  .house-view {
    .houses {
      width: 100%;
      overflow-x: scroll;
      margin: 12px 0;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .item {
        flex-shrink: 0;
        margin-right: 12px;
      }
    }
  }
  .tag-view {
    margin-top: 15px;
    padding: 10px;
    background-color: #ffffff;
    .tag-title {
      color: rgba(0, 0, 0, .8);
      font-size: 14px;
      &::before {
        content: '';
        display: inline-block;
        width: 3px;
        height: 12px;
        background-color: rgba(7, 193, 96, .6);
        border-top-right-radius: 50%;
        border-bottom-left-radius: 50%;
      }
    }
    .inline-btn {
      border-radius: 50%;
      background-color: rgba(0, 0, 0, .6);
    }
  }
  .content-view {
    position: relative;
    z-index: 11;
    padding: 14px .6rem;
    margin-top: -@contentMT;
    border-radius: 18px;
    background-color: #ffffff;
    .base-info {
      .detail-btn {
        margin: 8px 0;
      }
    }
    .price-view {
      color: #ff0000;
      margin: 12px 0 2px 0;
    }
    .info-view {
      .share {
        font-size: 12px;
      }
      .title {
        .name {
          font-size: 18px;
        }
        .tag {
          margin-top: 4px;
          font-size: 10px;
          .item {
            padding: 3px;
            background-color: #ebebeb;
            margin-right: 6px;
            &:last-child {
              margin: 0;
            }
          }
        }
      }
    }
  }
  .custom-indicator {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 30px;
    margin-bottom: @contentMT;
    z-index: 10;
    @indWidth: 6px;
    .item {
      width: @indWidth;
      height: @indWidth;
      border-radius: @indWidth / 2;
      background: #faf6f3;
      margin-right: 10px;
      transition: width .5s linear;
      &:last-child {
        margin: 0;
      }
      &.current {
        width: @indWidth * 3;
      }
    }
  }
  .fixed-view {
    position: fixed;
    top: 0;
    left: 0;
    width: 10rem;
    height: 44px;
    color: rgba(0, 0, 0, .8);
    background-color: #ffffff;
    z-index: 2001;
    transition: all .5s linear;
  }
}

/* 表单相关 */
.form-readonly {
  li {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 0;
    .label {
      color: rgba(0, 0, 0, .6);
      font-size: 13px;
      width: 2rem;
    }
    .value {
      font-size: 13px;
    }
  }
}
.lg-btn {
  height: 42px;
  background-color: rgba(7, 193, 96, 1);
  border: none;
}
</style>
